<template>
  <div class="index-container">
    <div class="form">
      <div class="form-item">
        <div class="label">门店：</div>
        <div class="value">
          <tenantSelector ref="tenantSelector" v-model="filters.tenant" />
        </div>
      </div>
      <div class="form-item">
        <div class="label">时间：</div>
        <div class="value">
          <dateOptionSelector
            size="small"
            v-model="filters.dateTime"
            ref="dateOptionSelector"
            :options="dateOptions"
          />
        </div>
      </div>
      <div class="form-item">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-s-data"
          @click="getData"
          >统计</el-button
        >
      </div>
    </div>
    <el-card class="box-card" style="height: 100%">
      <div slot="header" class="clearfix">
        <span style="font-size: 16px; font-weight: bold"
          ><i
            class="iconfont el-icon-guide"
            style="color: #67c23a; font-size: 16px"
          />订单总览</span
        >
      </div>
      <el-table stripe :data="rows" border>
        <el-table-column min-width="100" label="预约日期" prop="name">
          <template slot-scope="scope">
            <i
            class="el-icon-date" v-if="scope.row.name=='待接单'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-s-promotion" v-if="scope.row.name=='待派单'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-message-solid" v-if="scope.row.name=='改约中'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-user-solid" v-if="scope.row.name=='已派单'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-success" v-if="scope.row.name=='已完成'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-money" v-if="scope.row.name=='已结算'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-remove" v-if="scope.row.name=='已拒绝'"
            style="color: #67c23a; font-size: 16px"
          />
          <i
            class="el-icon-error" v-if="scope.row.name=='已取消'"
            style="color: #67c23a; font-size: 16px"
          />
          {{ scope.row.name }}
          </template>
        </el-table-column>
        <el-table-column :min-width="80" v-for="column in columns" :prop="column.prop" :label="column.text" :key="column.prop">
        </el-table-column>
      </el-table>
    </el-card>
    <el-card class="box-card" style="height: 100%">
      <div slot="header" class="clearfix">
        <span style="font-size: 16px; font-weight: bold"
          ><i
            class="iconfont el-icon-s-data"
            style="color: #f4516c; font-size: 16px"
          />
          营收数据</span
        >
      </div>
      <div class="row">
        <div class="item">
          <i class="el-icon-check" style="color: #67c23a; font-size: 25px" />
          <span>接入单数：{{ orderCount }}</span>
        </div>
        <div class="item">
          <span>接入均价：￥{{ orderUnitAmount }}</span>
        </div>
        <div class="item">
          <span>接入总额：￥{{ orderAmount }}</span>
        </div>
        <div class="item">
          <span>平台费用：￥{{ orderCost }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <i
            class="el-icon-s-promotion"
            style="color: #f4516c; font-size: 25px"
          />
          <span>派单单数：{{ dispatchCount }}</span>
        </div>
        <div class="item">
          <span>派单均价：￥{{ dispatchUnitAmount }}</span>
        </div>
        <div class="item">
          <span>派单总额：￥{{ dispatchAmount }}</span>
        </div>
        <div class="item">
          <span>接入利润：￥{{ orderInCome }}</span>
        </div>
      </div>
      <el-divider></el-divider>
      <div class="row">
        <div class="item">
          <i class="el-icon-success" style="color: #67c23a; font-size: 25px" />
          <span>完成单数：{{ completeCount }}</span>
        </div>
        <div class="item">
          <span>完成均价：￥{{ completeUnitAmount }}</span>
        </div>
        <div class="item">
          <span>完成总额：￥{{ completeAmount }}</span>
        </div>
        <div class="item">
          <span>平台费用：￥{{ completedCost }}</span>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <i
            class="iconfont iconjine1"
            style="color: #f4516c; font-size: 25px"
          />
          <span>结算单数：{{ balanceCount }}</span>
        </div>
        <div class="item">
          <span>结算均价：￥{{ balanceUnitAmount }}</span>
        </div>
        <div class="item">
          <span>结算总额：￥{{ balanceAmount }}</span>
        </div>
        <div class="item">
          <span>完成利润：{{ completeInCome }}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { analysis, processAnalysis } from "@/api/analysis.js";
import echart from "@/components/eChart";
import tenantSelector from "@/components/tenantSelector";
import dateOptionSelector from "@/components/dateOptionSelector";
export default {
  components: {
    tenantSelector,
    dateOptionSelector,
    echart,
  },
  data() {
    return {
      dateOptions: [{ value: "create", name: "时间区间" }],
      filters: {
        tenant: "",
        dateTime: {
          dateType: "create",
          date: [],
        },
      },
      loading: false,

      orderCount: 0,
      orderAmount: 0,
      orderUnitAmount: "-",
      orderCost:0,

      dispatchCount: 0,
      dispatchAmount: 0,
      dispatchUnitAmount: "-",
      orderInCome: 0,

      completeCount: 0,
      completeAmount: 0,
      completeUnitAmount: "-",
      completedCost:0,

      balanceCount: 0,
      balanceAmount: 0,
      balanceUnitAmount: "-",
      completeInCome: 0,

      columns:[],
      rows:[],
    };
  },
  methods: {
    getData() {
      if (!this.filters.dateTime || !this.filters.dateTime.date.length) {
        this.msg.errorMsg("请选择统计时间");
        return;
      }
      let param = {
        tenant: this.filters.tenant.Key,
        beginDate: this.filters.dateTime.date[0],
        endDate: this.filters.dateTime.date[1],
      };
      analysis(param)
        .then((res) => {
          this.orderCount = res.orderCount;
          this.orderAmount = res.orderAmount;
          this.orderUnitAmount = res.orderUnitAmount;
          this.orderCost=res.orderCost;

          this.dispatchCount = res.dispatchCount;
          this.dispatchAmount = res.dispatchAmount;
          this.dispatchUnitAmount = res.dispatchUnitAmount;
          this.orderInCome = res.orderInCome;
          this.completeCount = res.completeCount;
          this.completeAmount = res.completeAmount;
          this.completeUnitAmount = res.completeUnitAmount;
          this.completedCost= res.completedCost;
          
          this.balanceCount = res.balanceCount;
          this.balanceAmount = res.balanceAmount;
          this.balanceUnitAmount = res.balanceUnitAmount;
          this.completeInCome = res.completeInCome;
        })
        .catch((ex) => {
          this.msg.errorMsg(ex);
        });

      processAnalysis(param).then((res) => {
        if(res){
          this.rows=res.rows;
          this.columns = res.columns;
        }
      }).catch(ex=>{
        this.msg.errorMsg(ex);
      });
    },
  },
  mounted() {
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    const end = new Date();
    this.filters.dateTime.date = [start, end];
    setTimeout(() => {
      this.getData();
    }, 1000);
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-tabs--border-card > .el-tabs__content {
  padding: 0;
  height: 1px;
}

.tab-content {
  margin-top: -2px;
  border: 1px solid #dcdfe6;
  border-top: 0;
  padding: 15px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .item {
    flex: 1;
    padding: 10px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    span {
      margin-left: 20px;
      font-size: 20px;
    }
  }
}

.chart {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .item {
    flex: 1;
  }
}

.index-container {
  font-size: 20px;

  .content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0;

    .box {
      margin-top: 20px;
      background: white;
    }

    .panel {
      background: white;
      border-radius: 5px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 40px 60px;
      box-sizing: border-box;

      .iconfont {
        font-size: 80px;
        margin-right: 100px;
      }

      .name {
        margin-bottom: 20px;
        font-size: 25px;
      }

      .count {
        font-size: 40px;
        font-weight: bold;
        text-align: right;
      }
    }
  }
}
</style>